import React from 'react';


import './App.css';
import Navbar from './components/Navbar/Navbar.js';
import Home from './components/Home/Home.js';
import Skills from './components/Skills/Skills.js';
import Hobbies from './components/Hobbies/Hobbies.js';


function App() {
  return <React.Fragment>
            <Navbar/>
            <Home/>
            <Skills/>
            <Hobbies/>
        </React.Fragment>;
}

export default App;
